/* eslint-disable */
import { THEME_CHANGE_PALETTE_TYPE_LIGHT } from '../Theme.types';

/**
 * Change the type of the current palette to `light` mode
 * @returns {ActionCreator<FromPayload<null, {}, THEME_CHANGE_PALETTE_TYPE_LIGHT>>} The created `Action`
 */
const themeChangePaletteTypeLight = () => ({ fromPayload }) => {
  return fromPayload(null, {}, THEME_CHANGE_PALETTE_TYPE_LIGHT);
};

export default themeChangePaletteTypeLight;
